import { getFeature } from 'Cloud/Application/FeaturesEs6';

interface R7DesktopConfig {
    displayName: string;
    provider: string;
    domain: string;
}

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-19804 Параметры для десктоп R7
 */
export const r7DesktopConfig: R7DesktopConfig = getFeature('r7-desktop-config');
